import React, {useEffect, useMemo, useState} from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import ModificationService from 'services/ModificationService';
import {withRouter} from "react-router";
import {connect} from 'react-redux'
import PublishSection from './PublishSection';
import NoticeService from 'services/NoticeService';
import {DemandValidation} from 'constants/DemandValidation';
import isPublishButtonActive from 'libs/isPublishButtonActive';
import getUncompletedSections from 'libs/getUncompletedSections';
import NoticeButtons from './NoticeButtons';
import InformationSection from './InformationSection';
import RouterPath from "libs/RouterPath";
import {PublishConst} from 'constants/PublicationConst';
import isCancelModificationButtonActive from "libs/isCancelModificationButtonActive";
import {isDemandModification, isDemandPreparing} from "libs/getDemandStatus";
import Loading from "components/Loading";
import isPreviewButtonActive from "libs/isPreviewButtonActive";
import isPreviewNoticeButtonActive from "libs/isPreviewNoticeButtonActive";
import isPreviewDemandPublicFormButtonActive from "libs/isPreviewDemandPublicFormButtonActive";
import DemandService from "services/DemandService";
import {clearResource} from "redux/actions";
import clsx from 'clsx';
import BzpNoticeButtons from "./BzpNoticeButtons";
import EnoticeSection from "./EnoticeSection";
import NationalNoticeService from "services/NationalNoticeService";
import NationalNoticeStatus from "components/complex/nationalNotice/constants/NationalNoticeStatus";
import isBackToPreparingButtonActive from "libs/isBackToPreparingButtonActive";
import EnoticeStatus from "constants/EnoticeStatus";
import EnoticeAnnouncementStatus from "constants/EnoticeAnnouncementStatus";

const style = theme => ({
    root: {
        '&>*': {
            '&>*': {
                marginTop: theme.spacing(2)
            }
        }
    },
    hidden: {
        display: 'none'
    }
})

function Publication(
    {
        classes,
        expanded,
        match,
        demandValidation,
        noticePreview = {error: true},
        ojsPublicationStatus,
        isDemandChanged = {},
        demandHeader,
        bzpContractNoticeStatus,
        enoticeStatus,
    }) {
    const id = match.params.id;

    const [working, setWorking] = useState(true);
    const uncompletedSections = getUncompletedSections(demandValidation);
    const [noticeStatusInterval] = useState();

    const findSection = (compareSection) => demandValidation.find(x => x.section === compareSection);

    const section = findSection(DemandValidation.PUBLICATION);

    const editable = section ? section.editable : false;
    const ojsAdmin = section ? section.ojsAdmin : false;
    const hasOjsNotice = demandHeader?.noticeOjsType === true;
    const hasBzpNotice = demandHeader?.noticeBzpType === true;
    const isEnoticeType = demandHeader?.formType === "enotices2";

    const clearPublishResources = () => {
        DemandService.getValidate(id, false);
    }

    useEffect(() => {
        if (hasOjsNotice && id > 0) {
            if (isDemandPreparing()) {
                // PublishService.checkPublishOjs(id).then(resp => {
                //     setWorking(false);
                //     if (resp && resp.status === PublishConst.SENT) {
                //         startNoticeStatusInterval();
                //     }
                // })
            } else if (isDemandModification()) {
                // ModificationService.noticeOjsStatus(id).then(resp => {
                //     setWorking(false);
                //     if (resp && resp.status === PublishConst.SENT) {
                //         startNoticeStatusInterval();
                //     }
                // })
            } else {
                setWorking(false);
            }
        } else {
            setWorking(false);
        }


        return () => {
            if (noticeStatusInterval) clearInterval(noticeStatusInterval);
        }
        //eslint-disable-next-line
    }, []);

    const startNoticeStatusInterval = () => {
        if (isDemandPreparing()) {
            // const interval = setInterval(async () => {
            //     const resp = await PublishService.checkPublishOjs(id);
            //     if (resp.status !== PublishConst.SENT) {
            //         clearInterval(interval);
            //         clearPublishResources();
            //     }
            // }, 10000);
            // setNoticeStatusInterval(interval);
        } else if (isDemandModification()) {
            // const interval = setInterval(async () => {
            //     const resp = await ModificationService.noticeOjsStatus(id);
            //     if (resp.status !== PublishConst.SENT) {
            //         clearInterval(interval);
            //         clearPublishResources();
            //     }
            // }, 10000);
            // setNoticeStatusInterval(interval);
        }
    }

    useEffect(() => {
        if (isDemandModification()) {
            ModificationService.isDemandChanged(id);
        }

        if (expanded) {
            if (hasOjsNotice && uncompletedSections.length === 0) {
                NoticeService.getPreviewUrl(id);
                DemandService.clearResources(DemandService.DEMAND_RESOURCE_ID);
            }

            if (hasBzpNotice && uncompletedSections.length === 0) {
                if (isDemandModification()) {
                    NationalNoticeService.getContractModificationNoticeStatus(id);
                } else if (isDemandPreparing()) {
                    NationalNoticeService.getContractNoticeStatus(id);
                }
            }
        }
        return ()=> {
            NoticeService.clearResources(NoticeService.NOTICE_PREVIEW_RESOURCE_ID);
        }
        // eslint-disable-next-line
    }, [expanded, id])


    const rp = RouterPath.myProcedure;

    const moveToOfferCollection = () => {
        const href = RouterPath.createPath(rp.steps.MP_2_ID, {id});
        RouterPath.redirect(href)
    };
    const isPublishActive = useMemo(() => isPublishButtonActive(demandValidation, ojsPublicationStatus, bzpContractNoticeStatus, isDemandChanged, enoticeStatus), [demandValidation, ojsPublicationStatus, isDemandChanged, bzpContractNoticeStatus, enoticeStatus]);
    const isBackToPreparingActive = useMemo(() => isBackToPreparingButtonActive(demandValidation, section?.waitingForPublication, bzpContractNoticeStatus), [demandValidation, section, bzpContractNoticeStatus])
    const isCancelActive = isCancelModificationButtonActive(demandValidation, ojsPublicationStatus, bzpContractNoticeStatus);
    const isBackToModificationActive = useMemo(() => isDemandModification() && section?.waitingForPublication, [section])
    // eslint-disable-next-line
    const isPreviewActive = useMemo(() => isPreviewButtonActive(demandValidation), [demandValidation]);
    const isPreviewNoticeActive = useMemo(() => isPreviewNoticeButtonActive(demandValidation, bzpContractNoticeStatus), [demandValidation, bzpContractNoticeStatus]);
    const isPreviewDemandPublicFormActive = useMemo(() => isPreviewDemandPublicFormButtonActive(demandValidation), [demandValidation]);
    const isOjsProcessing = uncompletedSections.length === 0 && ojsPublicationStatus ? ojsPublicationStatus.status === PublishConst.SENT : false;
    const isPublicOjsActive = uncompletedSections.length === 0 && ojsPublicationStatus ? ojsPublicationStatus.status === PublishConst.NOT_SENT : false;
    const isPreviewOjsActive = uncompletedSections.length === 0 && !Boolean(noticePreview.error);

    const isBzpPublishActive = uncompletedSections.length === 0 && bzpContractNoticeStatus ? bzpContractNoticeStatus.status === NationalNoticeStatus.COMPLETED : false;
    const isBzpProcessing = uncompletedSections.length === 0 && bzpContractNoticeStatus ? bzpContractNoticeStatus.status === NationalNoticeStatus.SEND : false;

    const isEnoticeValidated = enoticeStatus ? enoticeStatus.internalFormStatus === EnoticeStatus.NEW : false;
    const isEnoticeStatusSubmitted = enoticeStatus ? enoticeStatus.internalFormStatus === EnoticeStatus.SUBMITTED && enoticeStatus.ueNoticeStatus !== EnoticeStatus.PUBLISHED : false;
    const isEnoticeStatusPublished = enoticeStatus ? enoticeStatus.internalFormStatus === EnoticeStatus.SUBMITTED && enoticeStatus.ueNoticeStatus === EnoticeStatus.PUBLISHED : false;
    const isEnoticeAnnouncementStatusWaiting = enoticeStatus ? isEnoticeStatusSubmitted && enoticeStatus.announcementStatus === EnoticeAnnouncementStatus.WAITING : false;
    const enoticePreferredPublicationDate = enoticeStatus?.preferredPublicationDate || null;

    if (!demandValidation || !demandHeader) return <Loading/>

    return (
        <>
            {working && <Loading/>}
            <GridBlock
                direction='column'
                alignItems='center'
                className={clsx({[classes.hidden]:working})}
            >
                <InformationSection
                    id={id}
                    classesRoot={classes.root}
                    isPublishActive={isPublishActive}
                    isPreviewActive={isPreviewActive}
                    isPreviewNoticeActive={isPreviewNoticeActive}
                    isPreviewDemandPublicFormActive={isPreviewDemandPublicFormActive}
                    isPublicOjsActive={isPublicOjsActive}
                    isPreviewOjsActive={isPreviewOjsActive}
                    isOjsProcessing={isOjsProcessing}
                    uncompletedSections={uncompletedSections}
                    demandHeader={demandHeader}
                    section={section}
                    isBzpProcessing={isBzpProcessing}
                    isBzpPublishActive={isBzpPublishActive}
                    isEuEnoticeStatusSuccess={isEnoticeValidated}
                    isEnoticeStatusSubmitted={isEnoticeStatusSubmitted}
                    isEnoticeStatusPublished={isEnoticeStatusPublished}
                />

                {(hasOjsNotice) &&
                <NoticeButtons
                    id={id}
                    editable={editable}
                    ojsAdmin={ojsAdmin}
                    noticePreview={noticePreview}
                    ojsPublicationStatus={ojsPublicationStatus}
                    isPublicOjsActive={isPublicOjsActive}
                    isPreviewOjsActive={isPreviewOjsActive}
                    classesRoot={classes.root}
                    checkNoticeStatus={startNoticeStatusInterval}
                    setWorking={setWorking}
                    clearPublishResources={clearPublishResources}
                />
                }

                {
                    (hasBzpNotice && uncompletedSections.length === 0) && <BzpNoticeButtons
                        id={id}
                        editable={editable}
                        classesRoot={classes.root}
                        setWorking={setWorking}
                        clearPublishResources={clearPublishResources}
                        bzpContractNoticeStatus={bzpContractNoticeStatus}
                    />
                }
                {
                    (isEnoticeType && uncompletedSections.length === 0) && <EnoticeSection
                        id={id}
                        editable={editable}
                        classesRoot={classes.root}
                        setWorking={setWorking}
                        clearPublishResources={clearPublishResources}
                        bzpContractNoticeStatus={bzpContractNoticeStatus}
                        isEuEnoticeStatusSuccess={isEnoticeValidated}
                        isEnoticeStatusSubmitted={isEnoticeStatusSubmitted}
                        isEnoticeStatusPublished={isEnoticeStatusPublished}
                        isEnoticeAnnouncementStatusWaiting={isEnoticeAnnouncementStatusWaiting}
                        preferredPublicationDate={enoticePreferredPublicationDate}
                    />
                }
                <PublishSection
                    id={id}
                    classesRoot={classes.root}
                    moveToOfferCollection={moveToOfferCollection}
                    isPublishActive={isPublishActive}
                    isCancelActive={isCancelActive}
                    isBackToPreparingActive={isBackToPreparingActive}
                    isBackToModificationActive={isBackToModificationActive}
                    editable={editable}
                    setWorking={setWorking}
                    clearPublishResources={clearPublishResources}
                    isEuEnoticeStatusSuccess={isEnoticeValidated}
                    isEnoticeStatusSubmitted={isEnoticeStatusSubmitted}
                    formType={demandHeader.formType}
                />
            </GridBlock>
        </>
    )
}

Publication.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    isDemandChanged: state.resources.isDemandChanged,
    noticePreview: state.resources.noticePreview,
    demandValidation: state.resources.demandValidation,
    ojsPublicationStatus: state.resources.ojsPublicationStatus,
    bzpContractNoticeStatus: state.resources[NationalNoticeService.BZP_CONTRACT_NOTICE_STATUS],
    demandHeader: state.resources.demandHeader,
    enoticeStatus: state.resources.enoticeStatus
}), {

    clearResource
})(withStyles(style)(withRouter(Publication)));